import { render } from "./PaymentRequests.vue?vue&type=template&id=aeecbb36&scoped=true&ts=true"
import script from "./PaymentRequests.vue?vue&type=script&lang=ts"
export * from "./PaymentRequests.vue?vue&type=script&lang=ts"

import "./PaymentRequests.vue?vue&type=style&index=0&id=aeecbb36&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeecbb36"]])

export default __exports__